import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { NumericScrubLabel } from "./NumericScrubLabel";
import { SCRUB_FIELD_LABEL_CLASS, SCRUB_FIELD_SHELL_CLASS } from "./scrubFieldStyles";

export function ScrubField({
  label,
  scrubValue,
  scrubMin,
  scrubMax,
  scrubStep = 1,
  scrubDisabled = false,
  onScrubChange,
  onScrubStart,
  onScrubEnd,
  scrubbable = true,
  className,
  children,
}: {
  label: string;
  scrubValue?: number;
  scrubMin?: number;
  scrubMax?: number;
  scrubStep?: number;
  scrubDisabled?: boolean;
  onScrubChange?: (value: number) => void;
  onScrubStart?: () => void;
  onScrubEnd?: () => void;
  scrubbable?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <label className={cn(SCRUB_FIELD_SHELL_CLASS, className)}>
      {scrubbable && onScrubChange ? (
        <NumericScrubLabel
          label={label}
          value={scrubValue}
          min={scrubMin}
          max={scrubMax}
          step={scrubStep}
          disabled={scrubDisabled}
          onChange={onScrubChange}
          onScrubStart={onScrubStart}
          onScrubEnd={onScrubEnd}
        />
      ) : (
        <span className={SCRUB_FIELD_LABEL_CLASS}>{label}</span>
      )}
      <div className="min-w-0 flex-1">{children}</div>
    </label>
  );
}
